const pageHasHeaderSlider = () => {
    const entryContentFirstChild = document.querySelector('.entry-content').children[0];

    if (! entryContentFirstChild) {
        return false;
    }

    const containsSlider = entryContentFirstChild.classList.contains('block-content-slider');
    const sliderIsFullWidth = entryContentFirstChild.classList.contains('alignfull');

    return containsSlider && sliderIsFullWidth;
};

const pageHasEntryHeaderWithBackground = () => {
    const entryHeader = document.querySelector('.entry-header');

    if (! entryHeader) {
        return false;
    }

    return entryHeader.classList.contains('has-primary-gradient-background');
};

if (! pageHasEntryHeaderWithBackground() && ! pageHasHeaderSlider()) {
    document.body.classList.add('no-header');
}

export { pageHasEntryHeaderWithBackground, pageHasHeaderSlider };
